import { render, staticRenderFns } from "./ColorUpdate.vue?vue&type=template&id=8b469504&"
import script from "./ColorUpdate.vue?vue&type=script&lang=js&"
export * from "./ColorUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports